import { render, staticRenderFns } from "./PosTransactions.vue?vue&type=template&id=6f4ed93b&scoped=true"
import script from "./PosTransactions.vue?vue&type=script&lang=js"
export * from "./PosTransactions.vue?vue&type=script&lang=js"
import style0 from "./PosTransactions.vue?vue&type=style&index=0&id=6f4ed93b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4ed93b",
  null
  
)

export default component.exports